"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _helpers = require("react-platform-components/dist/helpers");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _config = require("../config");
var _StoreActions = require("./StoreActions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  var _header;
  return {
    header: (_header = {
      backgroundColor: "#0a76a9",
      backgroundImage: "url(\"".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png\")"),
      backgroundSize: 'cover',
      color: '#fff',
      display: 'flex',
      height: '20vh',
      minHeight: '20vh'
    }, _defineProperty(_header, theme.breakpoints.down('sm'), {
      height: '55vh'
    }), _defineProperty(_header, theme.breakpoints.up('md'), {
      height: '20vh'
    }), _header)
  };
});
function Store(props) {
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _reactUse.useTitle)(props.intl.formatMessage({
    id: "Store page title",
    defaultMessage: "Store page title"
  }));
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var storeReducer = _ref.storeReducer,
        auth = _ref.auth;
      return {
        store: storeReducer.store,
        user: auth.user
      };
    }),
    store = _useSelector.store,
    user = _useSelector.user;
  (0, _react.useEffect)(function () {
    if (!user.store) {
      dispatch({
        type: 'REDIRECT',
        to: '/store-update',
        history: props.history
      });
    } else {
      dispatch({
        type: _StoreActions.FETCH_STORE,
        history: props.history
      });
    }
  }, []);
  (0, _react.useEffect)(function () {
    var _user$store;
    if (store && store.id && !store.description && !((_user$store = user.store) !== null && _user$store !== void 0 && _user$store.name)) {
      dispatch({
        type: 'REDIRECT',
        to: '/store-update',
        history: props.history
      });
    }
  }, [store]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "xs:p-12 md:p-12 pt-80 flex flex-1 flex-col items-center justify-center md:flex-row md:items-end ".concat(classes.header),
    style: {
      backgroundImage: store.background_url ? "url(\"".concat((0, _helpers.joinPaths)(_config.BASE_URL, store.background_url), "\")") : store.background_url
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start white"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-white",
    style: {
      marginBottom: -83
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: "172",
    width: "172",
    className: "border border-black border-solid object-contain",
    src: store.logo && store.logo.original ? (0, _helpers.joinPaths)(_config.BASE_URL, store.logo.original) : "".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png"),
    onError: function onError(_ref2) {
      var currentTarget = _ref2.currentTarget;
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = "".concat(_config.STATIC_PATH, "/assets/images/backgrounds/default-logo-store.png");
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    style: {
      marginRight: '2rem'
    },
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return dispatch({
        type: 'REDIRECT',
        to: '/store-update',
        history: props.history
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Edit"
  })), _config.SHOW_STORE_DETAILS_BUTTON && /*#__PURE__*/_react.default.createElement("a", {
    className: "no-underline",
    target: "_blank",
    href: "".concat(_config.BASE_URL).concat(props.storeDetailsEndpoint || _config.STORE_PAGE, "/").concat(store.id)
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Detail"
  }))))), /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: "mt-8 m-4 p-4 py-8 lg:px-24"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    justify: "center",
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h4"
  }, store.name)), store.description && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    style: {
      marginBottom: '1rem',
      marginTop: '1rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Description"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "whitespace-pre-line"
  }, store.description))), _config.SHOW_STORE_IMAGES && store.images && store.images.length > 0 && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    style: {
      marginBottom: '1rem',
      marginTop: '1rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Images"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    xs: 12
  }, store.images.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      style: {
        marginRight: '1rem'
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      height: "172",
      width: "172",
      className: "object-contain",
      src: (0, _helpers.joinPaths)(_config.BASE_URL, item.url)
    }));
  }))))));
}
var _default = (0, _reactRouterDom.withRouter)((0, _Translations.injectIntl)(Store));
exports.default = _default;